import React, { PureComponent } from "react";
import classes from "./ForthBlock.module.css";
import cn from "clsx";
import Typography from "src/components/ui-kit/Typography";
import Container from "src/components/ui-kit/Container";

interface ForthBlockProps {}

class ForthBlock extends PureComponent<ForthBlockProps> {
  render(): React.ReactNode {
    return (
      <div className={cn(classes.container)}>
        <Container>
          <Typography variant="h2" component="h3" color="primary">
            <b>Мы помогаем животным, у которых временно нет людей</b>
          </Typography>
          <div className={cn(classes.bulletPoints)}>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img src={require("./assets/1.svg")} alt="Иконка сердца" />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Развивать культуру ответственного отношения к братьям нашим
                    меньшим — наша общая цель. Собаки, кошки и другие питомцы не
                    могут позаботиться о себе сами или попросить о помощи. И
                    только человек может обеспечить им достойную жизнь в
                    безопасном и любящем доме.
                  </b>
                </Typography>
              </div>
            </div>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img src={require("./assets/2.svg")} alt="Иконка конверта" />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Когда мы вместе и делаем общее дело, обеспечивая попавшим в
                    трудную ситуацию животным, жертвам жестокости и
                    безответственности, защиту и заботу, которых те заслуживают
                    — мы одновременно спасаем жизни и делаем лучше всех нас и
                    наш город, наш общий дом.
                  </b>
                </Typography>
              </div>
            </div>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img src={require("./assets/3.svg")} alt="Иконка сердца" />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Мы знаем, что рядом есть люди, которые готовы помочь, люди,
                    готовые взять животное из приюта и заботиться о нем. Просто
                    зачастую они не знают, куда обратиться, с кем поговорить,
                    как стать полезным. Мы верим, что стерилизация и желание
                    будущего владельца взять питомца из приюта — два важных шага
                    на пути к ответственному отношению к животным.
                  </b>
                </Typography>
              </div>
            </div>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img src={require("./assets/4.svg")} alt="Иконка кошки" />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Приюты и фонды помощи не забирают животных «с диванов». Туда
                    попадают коты и собаки, потерявшие хозяев, жертвы жестокого
                    или безответственного обращения. У каждого подопечного —
                    своя история, и она всегда печальна. Часто трагедия животных
                    — это и человеческая трагедия.
                  </b>
                </Typography>
              </div>
            </div>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img src={require("./assets/5.svg")} alt="Иконка собаки" />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Питомцы, ожидающие своих людей, замечательны все без
                    исключения. Они очень разные: и по характеру, и внешне. Им
                    просто нужен человек, нужна любовь и забота. И всегда очень
                    радостно, когда люди и животные находят друг друга.
                  </b>
                </Typography>
              </div>
            </div>
            <div>
              <div className={cn(classes.imgContainer)}>
                <img
                  src={require("./assets/6.svg")}
                  alt="Иконка человека, что любит питомца"
                />
              </div>
              <div>
                <Typography color="primary" isSemiTransperent component="span">
                  <b>
                    Если вы мечтаете о коте или собаке, познакомьтесь с ним в
                    приюте или Adoption-центре. Очень может быть, что ваш
                    любимец ждет вас именно там!
                  </b>
                </Typography>
              </div>
            </div>
          </div>
          <hr className={cn(classes.separator)} />
          <Typography
            color="primary"
            isSemiTransperent
            className={cn(classes.lastTextBlock)}
          >
            <b>
              В продолжение акции МаксимаТелеком и Квант запустят платформу
              «Хвосты и лапки». Задача платформы — помочь не только животным, но
              и людям. На этом общем портале московские приюты, фонды, волонтеры
              и просто неравнодушные люди смогут разместить информацию о своих
              подопечных и помочь им найти хозяев и дом. И в скором времени
              пассажиры Московского транспорта и все горожане смогут
              пользоваться большим и удобным каталогом для поиска своих будущих
              питомцев.
            </b>
          </Typography>
        </Container>
      </div>
    );
  }
}

export default ForthBlock;
